import {useSelector} from 'react-redux'

import {selectUser} from 'features/User'

// These are the domains to which we are allowing full CASB rollout (without paywall).
const allowedDomainsForFeatureRollouts = [
  'dope.security',
  'infotechoutreach.onmicrosoft.com',
  'zm6lv.onmicrosoft.com',
  'swgtest.onmicrosoft.com',
  'sanjoydeb.com',
  'pb7q.onmicrosoft.com',
  'valuexpa.onmicrosoft.com',
  'dopesec.in',
  'dopesectest.in',
  'dopeo365.onmicrosoft.com',
  '4vtzc0.onmicrosoft.com',
  'samaatechnologies.com',
  'mellivoratech.co',
  'nextsolutions-global.com',
  'thegrowfi.com',
  'cloudfactory.dk',
  'boldstart.vc',
  'lsvp.com',
  'prefaceventures.com',
  'plansource.com',
  'leadingedgetrng.com',
  'successacademies.org',
  'spar.net',
  'dolphin.africa',
  'observa.com',
  'archtopfiber.com',
  'paydhealth.com',
  'apexsystems.co',
  'brain-networks.fr',
  'colondon.onmicrosoft.com',
  'spellmanhv.com',
  'alpineinvestors.onmicrosoft.com',
  'mmimicro.com',
  'spearshield.co.uk',
  'itracium.com',
  'b2c2.com',
  'alpha-sense.com',
  'outreachhealth.com',
  'mak-system.net',
  'openly.com',
  'getethos.com',
  'goldengatecap.com',
  'fortitude-re.com',
  'rwcm.com',
  'kleinerperkins.com',
  'greathillpartners.com',
  'fortitude-re.com',
  'parthenoncapital.com',
  'havebury.com',
  'cerberus.com',
  'carehospitals.com',
  'firstmark.com',
  'firstround.com',
  'invcg.com',
  'altos.vc',
  'canohealth.com',
  'mitsogo.com',
  'arclightcapital.com',
  'monolithicpower.com',
  'imaginepediatrics.org',
  'paul-mccoy.com',
  'luminorgroup.com',
  'kayenta.io',
  'moodmedia.com',
  'profoundresearch.io',
  'postpilot.com',
  'thomabravo.com',
]

interface useAllowedDomainsCheckReturnType {
  isPaywalled: boolean
}

interface useAllowedDomainsCheckProps {
  showPaywallCheck?: boolean
}

export const useAllowedDomainsCheck = ({
  showPaywallCheck = true,
}: useAllowedDomainsCheckProps = {}): useAllowedDomainsCheckReturnType => {
  const {primaryDomain} = useSelector(selectUser)

  const isPaywalled =
    !allowedDomainsForFeatureRollouts.includes(primaryDomain) &&
    showPaywallCheck

  return {isPaywalled}
}
